// extracted by mini-css-extract-plugin
export default {"main":"App_main__N0q-4","interactiveBox":"App_interactiveBox__ClDvB"};